export const AB_TESTING_LOGGING_GROUP: string = 'AB-Testing';
export const AB_TESTING_GET_PARAMETER_VALUE_ERROR_CODE: string = 'ABTESTING-ERROR-0';
export const AB_TESTING_GET_PARAMETERS_VALUES_ERROR_CODE: string = 'ABTESTING-ERROR-1';
export const AB_TESTING_LOG_EVENT_ERROR_CODE: string = 'ABTESTING-ERROR-2';
export const AB_TESTING_LOGGED_EVENTS_FEATURE_FLAG_PARSE_ERROR_CODE: string = 'ABTESTING-ERROR-3';
